export default __webpack_public_path__ + "static/media/logout.5aa52bce.svg";